import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, refetchOnWindowFocus: false },
  },
});

const isPhone = window.matchMedia("(max-width: 767px)").matches;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster theme="dark" position={isPhone ? "top-center" : "bottom-center"} mobileOffset={{ top: "calc(4.75rem + env(safe-area-inset-top))" }} toastOptions={{ style: { background: "#121212", border: "1px solid rgba(255,255,255,0.1)", color: "#F3F1EC" } }} />
    </QueryClientProvider>
  </React.StrictMode>,
);
